import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setupNavigation } from "../../../redux/actions/navItemsActions"
import { loadUserProfile } from "../../../redux/actions/userActions"
import { updateGeneralSettings } from "../../../redux/actions/settingsActions"
import GeneralSettingsForm from "./GeneralSettingsForm";
import Spinner from "../../common/Spinner";
import { toast } from "react-toastify";
import "../profile/ProfilePage.css";
import EditProfileBanner from "./EditProfileBanner";

function GeneralSettingsPage({
    user,
    auth,
    setupNavigation,
    loadUserProfile,
    updateGeneralSettings,
    updateSiteSettings,
    settings,
    changePassword,
    history,
    ...props
}) {

    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(true);
    const [settingDetails, setSettingDetails] = useState({
        firstName: "",
        surname: "",
        email: "",
        location: "",
        preferredMeasurementUnits: "0",
        subscribedMarketingNotification: false,
        subscribedRideBlogsNotification: false,
        approveFollowers: false,
        avatar: { src: "", preview: "" }
    });

    const navigationItems =
    {
        sections: [
            {
                name: 'Settings',
                showTitle: true,
                items: [
                    {
                        path: '/user/settings/general',
                        text: 'General Settings',
                        icon: 'fas fa-tasks'
                    },
                    {
                        path: '/user/settings/site',
                        text: 'Site Settings',
                        icon: 'fas fa-cogs'
                    },
                    {
                        path: '/user/settings/security',
                        text: 'Security',
                        icon: 'fas fa-key'
                    },
                    {
                        path: '/user/settings/garmin',
                        text: 'Garmin Connect',
                        icon: 'fas fa-mobile-android-alt'
                    },
                    {
                        path: '/user/settings/closeaccount',
                        text: 'Close Account',
                        icon: 'fas fa-user-times'
                    }
                ]
            }
        ]
    };

    useEffect(() => {
        document.title = "General Settings | JustGoRide";
        setupNavigation(navigationItems);
        if (!user || !user.id) {
            history.push("/login");
        }
        if (!settings.email) {
            setProcessing(true);
            loadUserProfile(user.id)
                .then((s) => {
                    s.avatarDetails = { src: "", preview: s.avatar }
                    setSettingDetails(s);
                    setProcessing(false);
                })
        }
        else {
            settings.avatarDetails = { src: "", preview: settings.avatar }
            setSettingDetails(settings);
            setProcessing(false);
        }
    }, []);

    function handleChange(event) {
        var { name, value } = event.target;
        if (name === "subscribedMarketingNotification") {
            value = event.target.checked;
        }
        if (name === "subscribedRideBlogsNotification") {
            value = event.target.checked;
        }
        if (name === "approveFollowers") {
            value = event.target.checked;
        }

        setSettingDetails(prevSettingDetails => ({
            ...prevSettingDetails,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: undefined
        }));
    }

    function generalFormIsValid() {
        const errors = {};
        var isValid = true;

        if (!settingDetails.firstName) {
            errors.firstName = "First Name is required.";
            setErrors(errors);
            isValid = false;
        }

        if (!settingDetails.surname) {
            errors.surname = "Surname is required.";
            setErrors(errors);
            isValid = false;
        }

        if (!settingDetails.email) {
            errors.email = "Email address is required.";
            setErrors(errors);
            isValid = false;
        } else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(settingDetails.email)) {
            errors.email = "Email address format invalid.";
            setErrors(errors);
            isValid = false;
        }

        return isValid;
    }

    function handleGeneralSave(event) {
        event.preventDefault();

        if (!generalFormIsValid()) return;
        setProcessing(true);
        updateGeneralSettings(settingDetails).then(() => {
            toast.success("General Settings Saved");
            setErrors({});
            setProcessing(false);
        })
            .catch(error => {
                setProcessing(false);
                setErrors({ onGeneralSave: error.message });
            });
    }

    return (
        processing ?
            <Spinner /> :
            <div>
                <EditProfileBanner title="General Settings" />
                <div className="settings-container row justify-content-md-center pb-5">
                    <GeneralSettingsForm
                        settings={settingDetails}
                        errors={errors}
                        onChange={handleChange}
                        onSave={handleGeneralSave}
                        processing={processing}
                    />
                </div>
            </div>
        
    );

}



GeneralSettingsPage.propTypes =
{
    setupNavigation: PropTypes.func.isRequired,
    loadUserProfile: PropTypes.func.isRequired,
    updateGeneralSettings: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    errorMessage: PropTypes.string
}


function mapStateToProps(state) {
    return {
        user: state.user,
        settings: state.settings,
        auth: state.auth
    };
}

const mapDispatchToProps = {
    setupNavigation,
    loadUserProfile,
    updateGeneralSettings
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneralSettingsPage);






// WEBPACK FOOTER //
// ./src/components/user/settings/GeneralSettingsPage.js